'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.imageComparison = twentyninetimes.imageComparison || function () {

	function init() {
		let image_comparisons = document.querySelectorAll('.js-comparison-slider');

		if ( image_comparisons ) {
			imageComparisonFunction(image_comparisons);
		}
	}

	function imageComparisonFunction(comparisons) {
		comparisons.forEach(comparison => {
		    var comparison_input    = comparison.querySelector('.js-comparison-input'),
		        comparison_handle   = comparison.querySelector('.js-comparison-handle'),
		        comparison_before   = comparison.querySelector('.js-comparison-before');

		    comparison_input.addEventListener('input', function(e) {
		        const sliderPos = e.target.value;

		        comparison_before.style.width = `${sliderPos}%`;

		        comparison_handle.style.left = `calc(${sliderPos}% - 1px)`;
		    });
		});
	}

	return {
		init : init
	};

}();